// Rótulos legíveis das permissões
export const LABELS_PERMISSIONS = {
  '/': 'Início',
  '/profile': 'Perfil',
  '/historico': 'Histórico',
  '/painel-atendimentos': 'Painel de Atendimentos',
  '/importar-movidesk': 'Importar Movidesk',
  '#finalizar-em-espera': 'Finalizar atendimento em espera',
  // Sem este rótulo a permissão apareceria como `#finalizar-atendimento-de-outro`
  // cru, na categoria "Outros" -- e é justamente ela que o administrador
  // precisa achar para liberar o encerramento pelo Painel de Atendimentos.
  '#finalizar-atendimento-de-outro': 'Finalizar atendimento de outro operador',
  '#transferir-atendimentos': 'Pegar/transferir atendimentos da fila',
  '/indicadores': 'Indicadores',
  '/tempo-tickets': 'Tempo em tickets',
  '/clientes/pesquisa': 'Clientes',
  '/configuracoes': 'Configurações',
  '/ia-base-conhecimento': 'IA / Base de Conhecimento',
  // Separada da de cima em 03/11/2026: as duas telas eram uma permissão só, e
  // com isso "dar os vídeos ao operador sem dar a IA" não era configurável.
  // O rótulo diz VÍDEOS E MANUAIS porque a tela tem as duas abas -- quem
  // concedesse lendo só "Vídeos" não esperaria estar dando os manuais junto.
  '/ia-base-conhecimento/videos': 'Vídeos e manuais (base de conhecimento)',
  // Sem este rótulo a permissão apareceria como `/whatsapp` cru, na categoria
  // "Outros" -- e é justamente ela que o administrador precisa achar quando um
  // operador vê a recusa por falta de permissão na tela de WhatsApp.
  '/whatsapp': 'WhatsApp (números do tenant)',
  '/operadores': 'Operadores',
  '/alterar-operador': 'Alterar operador',
  '/novo-operador': 'Novo operador',
  '#profile-form': 'Formulário de perfil',
  '#history-users': 'Histórico de usuários',
  '#inactivate-operator': 'Inativar operador',
  '#change-profile': 'Alterar perfil',
  '#gerenciar-perfis': 'Gerenciar perfis',
  '#gerenciar-tickets': 'Gerenciar tickets',
  '#criar-filtros-padrao': 'Criar filtros padrão',
  '#view-internal-tickets': 'Ver tickets internos',
  '#view-internal-comments': 'Ver comentários internos',
  '#view-financial-info': 'Ver informações financeiras do cliente',
  '#editar-dados-cliente': 'Editar dados do cliente (cadastro)',
  // Separada da de cadastro de propósito (decisão de 05/10): quem define a
  // fase (comercial, treinamento) não é necessariamente quem edita cadastro.
  // Sem esta linha a permissão cairia em "Outros" com a string crua como
  // rótulo -- concedível, mas incompreensível para quem administra.
  '#editar-fase-relacionamento': 'Editar fase do relacionamento do cliente',
  // Fixar material no topo da base (Gisele, 23/10/2026). Sem o rotulo a
  // permissao ainda apareceria -- no grupo 'Outros', com a chave crua --, e
  // quem fosse conceder leria '#fixar-material-da-base'.
  '#fixar-material-da-base': 'Fixar vídeos e manuais no topo da base',
  // Editar o material da base. É esta que dá ao LÍDER o que a Gisele pediu
  // ("editar vídeos"), e é por ela que o operador deixa de editar. Separada de
  // APAGAR de propósito: apagar continua sendo do administrador, porque tira o
  // material da base e do índice do Orby e não tem desfazer.
  '#editar-material-da-base': 'Editar vídeos e manuais da base',
  '#mesclar-tickets': 'Mesclar e relacionar tickets',
  '#excluir-tickets': 'Excluir tickets',
  '#editar-todas-acoes-ticket': 'Editar todas as ações do ticket',
  '#pausar-status-online-operadores': 'Alternar status ativo e inativo (presença online)',
  '#gerenciar-status-operadores': 'Alterar status (sistema/chat) de outros operadores no painel',
  '#gerenciar-horarios-servico': 'Gerenciar horários de serviço (departamento)',
  '#gerenciar-macros': 'Gerenciar macros de qualquer criador (inclui o lembrete da caixa de ação)',
  '#editar-ramal-usuario': 'Editar o ramal (URA) dos usuários',
  '#avaliar-feedback-ia': 'Avaliar feedback (likes/dislikes) das respostas do Orby',
  '/criar-avisos-mural': 'Criar avisos no mural',
};

// Categorias de permissões (chave → categoria)
export const PERMISSION_CATEGORIES = {
  // Páginas (rotas principais do sistema)
  'pages': {
    key: 'pages',
    label: 'Páginas',
    description: 'Acesso às páginas e rotas do sistema.',
    permissions: ['/', '/profile', '/historico', '/indicadores', '/tempo-tickets', '/clientes/pesquisa', '/configuracoes', '/ia-base-conhecimento', '/ia-base-conhecimento/videos', '/whatsapp', '/operadores'],
  },
  // Botões e elementos de interface
  'buttons': {
    key: 'buttons',
    label: 'Botões e elementos',
    description: 'Botões, formulários e elementos específicos da interface.',
    // As tres acoes de supervisor do Painel de Atendimentos (transferir,
    // finalizar da fila, encerrar o atendimento de outro) moram aqui, e nao
    // em "Outros": sao tres botoes do mesmo cartao da mesma tela, e separa-las
    // obrigava o administrador a cacar uma por uma em duas categorias.
    permissions: ['#profile-form', '#history-users', '#inactivate-operator', '#change-profile', '#gerenciar-perfis', '#gerenciar-tickets', '#transferir-atendimentos', '#finalizar-em-espera', '#finalizar-atendimento-de-outro', '#criar-filtros-padrao', '#view-internal-tickets', '#view-internal-comments', '#view-financial-info', '#editar-dados-cliente', '#editar-fase-relacionamento', '#mesclar-tickets', '#excluir-tickets', '#editar-todas-acoes-ticket', '#pausar-status-online-operadores', '#gerenciar-status-operadores', '#gerenciar-horarios-servico', '#gerenciar-macros', '#editar-ramal-usuario', '#fixar-material-da-base', '#editar-material-da-base'],
  },
  // Ações (operações como criar/alterar operador)
  'actions': {
    key: 'actions',
    label: 'Ações',
    description: 'Permissão para executar ações no sistema.',
    permissions: ['/alterar-operador', '/novo-operador', '/criar-avisos-mural'],
  },
};

// Permissões que não estão em nenhuma categoria listada vão para "Outros"
export const getCategoriesWithPermissions = (availablePermissions) => {
  const used = new Set();
  const categories = Object.values(PERMISSION_CATEGORIES).map((cat) => ({
    ...cat,
    permissions: cat.permissions.filter((p) => availablePermissions.includes(p)),
  }));
  categories.forEach((c) => c.permissions.forEach((p) => used.add(p)));
  const others = (availablePermissions || []).filter((p) => !used.has(p));
  if (others.length > 0) {
    categories.push({
      key: 'others',
      label: 'Outros',
      description: 'Demais permissões do sistema.',
      permissions: others,
    });
  }
  return categories.filter((c) => c.permissions.length > 0);
};

export const labelForPermission = (key) => LABELS_PERMISSIONS[key] || key;
